import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "../../Containers/Home/home";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import ScrollButton from "../../Common/ScrollTop/scrolButton";
import AboutUs from "../../Containers/AboutUs/aboutUs";
import WhatItMeansToBeMbrdi from "../../Containers/WhatItMeansToBeMbrdi/WhatItMeansToBeMbrdi";
import PressRelease from "../../Containers/PressRelease/pressRelease";
import Csr from "../../Containers/Csr/Csr";
import Benefits from "../../Containers/Benefits/Benefits";
import Privacy from "../../Containers/Privacy/privacy";
import "./Layout.scss";
import InNews from "../../Containers/InNews/inNews";
import EHS from "../../Containers/Ehs/ehs";
import HiringOppurtunities from "../../Containers/HiringOpportunities/hiringOpportunities";
import PeoplePractise from "../../Containers/PeoplePractice/peoplePractise";
// import PrideImpact from "../../Containers/PrideAndImpact/prideImpact";
// import Innovations from "../../Containers/Innovations/Innovations";
import ElectricRoutes from "../../Containers/ElectricRoutes/electricRoutes";
import ContactUs from "../../Containers/ContactUs/ContactUs";
import WhatWeDo from "../../Containers/WhatWeDo/whatWeDo";
import Sustainability23 from "../../Containers/Sustainability/Sustainability23/Sustainability23";
import Sustainability24 from "../../Containers/Sustainability/Sustainability24/Sustainability24";
import Sustainability25 from "../../Containers/Sustainability/Sustainability25/Sustainability25";
import SustainabilityGarage from "../../Containers/SustainabiltyGarage/SustainabilityGarage";
import EventAgenda from "../../Containers/Sustainability/Sustainability23/EventAgenda/EventAgenda";
import Support from "../../Containers/Sustainability/Support/Support";
import JoinUs from "../../Containers/JoinUs/JoinUs";
import MbrdiExperience from "../../Containers/MbrdiExperience/mbrdiExperience";
import PwdsMbrdi from "../../Containers/PwdsMbrdi/pwdsMbrdi";
import VehiclePrivacyPolicy from "../../Containers/VehiclePrivacyPolicy/VehiclePrivacy";
// import CookieConsent from "react-cookie-consent";

// let isMobile = false;

export default function Layout() {
  const location = useLocation();

  // const handleWindowSizeChange = () => {
  //   isMobile = window.innerWidth < 700 ? true : false;
  // };

  // useEffect(() => {
  //   window.addEventListener("resize", handleWindowSizeChange);
  //   return () => {
  //     window.removeEventListener("resize", handleWindowSizeChange);
  //   };
  // }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const cookieConsent = () => {
    // let styleResponsive = !isMobile
    //   ? {
    //       background: "#fff",
    //       display: "block",
    //       top: "40%",
    //       position: "fixed",
    //       width: window.innerWidth / 2.5,
    //       left: window.innerWidth / 3,
    //     }
    //   : {
    //       background: "#fff",
    //       display: "block",
    //       top: "40%",
    //       position: "fixed",
    //       width: window.innerWidth,
    //     };
    // return (
    //   <CookieConsent
    //     contentClasses="cookie-consent"
    //     location={"middle"}
    //     buttonText="Agree"
    //     declineButtonText="Close"
    //     enableDeclineButton
    //     flipButtons
    //     style={styleResponsive}
    //     buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
    //     expires={150}
    //   >
    //     <h1 className="cookie-title">We use cookies</h1>
    //     <p className="consent-details">
    //       We want to make our website more user-friendly and continuously
    //       improve it. If you continue to use the website, you agree to the use
    //       of cookies.
    //     </p>
    //     <a className="consent-link" target="new" href="#/privacy">
    //       For more information, please refer to our Privacy Statement
    //     </a>
    //   </CookieConsent>
    // );
  };

  return (
    <div>
      <Header></Header>
      {/* {cookieConsent()} */}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route exact path="/privacy" element={<Privacy />} />
        <Route exact path="/press-release" element={<PressRelease />} />
        <Route exact path="/about-us" element={<AboutUs />} />
        <Route exact path="/mbrdi-experience" element={<MbrdiExperience />} />
        <Route exact path="/what-we-do" element={<WhatWeDo />} />
        <Route exact path="/in-the-news" element={<InNews />} />
        <Route exact path="/ehs" element={<EHS />} />
        <Route
          exact
          path="/hiring-opportunities"
          element={<HiringOppurtunities />}
        />
        <Route exact path="/csr" element={<Csr />} />
        <Route
          exact
          path="/what-it-means-to-be-mbrdi"
          element={<WhatItMeansToBeMbrdi />}
        />
        <Route exact path="/benefits" element={<Benefits />} />
        <Route exact path="/people-practise" element={<PeoplePractise />} />
        {/* <Route exact path="/pride-impact" element={<PrideImpact />} /> */}
        <Route exact path="/join-us" element={<JoinUs />} />
        <Route exact path="/pwds-mbrdi" element={<PwdsMbrdi />} />
        {/* <Route exact path="/innovations" element={<Innovations />} /> */}
        <Route exact path="/electric-routes" element={<ElectricRoutes />} />
        <Route exact path="/contact-us" element={<ContactUs />} />
        <Route
          exact
          path="/vehicle-privacy-policy"
          element={<VehiclePrivacyPolicy />}
        />
        <Route
          exact
          path="/legal-compliance"
          element={<VehiclePrivacyPolicy />}
        />
        <Route
          exact
          path="/sustainability-garage"
          element={<SustainabilityGarage />}
        />
        <Route exact path="/sustainability-23" element={<Sustainability23 />} />
        <Route exact path="/sustainability-24" element={<Sustainability24 />} />
        <Route exact path="/sustainability-25" element={<Sustainability25 />} />
        <Route exact path="/event-agenda-23" element={<EventAgenda />} />
        <Route exact path="/support-23" element={<Support />} />
        <Route exact path="/support-24" element={<Support />} />
        <Route exact path="/support-25" element={<Support />} />
      </Routes>
      <Footer></Footer>
      <ScrollButton />
    </div>
  );
}
